// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ========== RESET & BASE ========== */
*, *::before, *::after {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}

:root {
  --primary: #6366f1;
  --primary-dark: #4f46e5;
  --primary-light: #e0e7ff;
  --danger: #ef4444;
  --danger-light: #fee2e2;
  --warning: #f97316;
  --warning-light: #ffedd5;
  --success: #22c55e;
  --bg: #f8fafc;
  --surface: #ffffff;
  --border: #e2e8f0;
  --text: #1e293b;
  --text-muted: #64748b;
  --radius: 12px;
  --shadow: 0 1px 3px rgba(0,0,0,.08), 0 4px 16px rgba(0,0,0,.06);
  --shadow-lg: 0 4px 24px rgba(99,102,241,.15);
}

/* ========== DARK MODE ========== */
[data-theme="dark"] {
  --bg: #0f172a;
  --surface: #1e293b;
  --border: #334155;
  --text: #f1f5f9;
  --text-muted: #94a3b8;
  --primary-light: #1e1b4b;
  --danger-light: #2d0a0a;
  --shadow: 0 1px 3px rgba(0,0,0,.4), 0 4px 16px rgba(0,0,0,.3);
  --shadow-lg: 0 4px 24px rgba(99,102,241,.3);
}

[data-theme="dark"] .subject-card--full {
  background: linear-gradient(135deg, #1e293b 0%, #2d1515 100%);
}

[data-theme="dark"] .btn--decrement {
  background: #1e1b4b;
  color: #a5b4fc;
}

[data-theme="dark"] .btn--decrement:hover:not(:disabled) {
  background: #312e81;
}

body {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
  background: var(--bg);
  color: var(--text);
  min-height: 100dvh;
  -webkit-font-smoothing: antialiased;
  transition: background 0.2s, color 0.2s;
}

/* ========== LOGIN PAGE ========== */
.login-page {
  min-height: 100dvh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1rem;
  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 50%, #a78bfa 100%);
}

.login-card {
  background: var(--surface);
  border-radius: 20px;
  padding: 2.5rem 2rem;
  width: 100%;
  max-width: 380px;
  box-shadow: 0 20px 60px rgba(0,0,0,.2);
  text-align: center;
}

.login-icon {
  font-size: 3rem;
  margin-bottom: 0.75rem;
}

.login-title {
  font-size: 1.75rem;
  font-weight: 700;
  color: var(--text);
  margin-bottom: 0.25rem;
}

.login-subtitle {
  color: var(--text-muted);
  font-size: 0.9rem;
  margin-bottom: 1.75rem;
}

.error-banner {
  background: var(--danger-light);
  color: var(--danger);
  border-radius: 8px;
  padding: 0.75rem 1rem;
  font-size: 0.875rem;
  margin-bottom: 1.25rem;
  line-height: 1.4;
}

.login-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.6rem;
  width: 100%;
  padding: 0.875rem 1.5rem;
  background: var(--primary);
  color: #fff;
  border: none;
  border-radius: 10px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s, transform 0.1s;
  font-family: inherit;
}

.login-btn:hover {
  background: var(--primary-dark);
}

.login-btn:active {
  transform: scale(0.98);
}

.login-btn-icon {
  width: 20px;
  height: 20px;
}

/* ========== DASHBOARD ========== */
.dashboard {
  min-height: 100dvh;
  display: flex;
  flex-direction: column;
}

.dashboard-header {
  background: var(--surface);
  border-bottom: 1px solid var(--border);
  padding: 0.875rem 1rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: sticky;
  top: 0;
  z-index: 10;
  box-shadow: 0 1px 4px rgba(0,0,0,.06);
}

.dashboard-title {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.dashboard-icon {
  font-size: 1.4rem;
}

.dashboard-title h1 {
  font-size: 1.2rem;
  font-weight: 700;
  color: var(--primary);
}

.dashboard-user {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.user-name {
  font-size: 0.8rem;
  color: var(--text-muted);
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.theme-btn {
  background: none;
  border: 1px solid var(--border);
  border-radius: 8px;
  width: 34px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s;
  flex-shrink: 0;
}

.theme-btn:hover {
  background: var(--primary-light);
  border-color: var(--primary);
}

.logout-btn {
  background: none;
  border: 1px solid var(--border);
  color: var(--text-muted);
  border-radius: 8px;
  padding: 0.35rem 0.75rem;
  font-size: 0.8rem;
  cursor: pointer;
  font-family: inherit;
  transition: background 0.15s, color 0.15s;
}

.logout-btn:hover {
  background: var(--danger-light);
  color: var(--danger);
  border-color: var(--danger);
}

.dashboard-main {
  flex: 1 1;
  padding: 1.25rem 1rem 2rem;
  max-width: 900px;
  margin: 0 auto;
  width: 100%;
}

/* ========== ADD FORM ========== */
.add-section {
  margin-bottom: 1.5rem;
}

.add-form {
  display: flex;
  gap: 0.5rem;
}

.add-input {
  flex: 1 1;
  padding: 0.75rem 1rem;
  border: 1.5px solid var(--border);
  border-radius: var(--radius);
  font-size: 0.95rem;
  font-family: inherit;
  background: var(--surface);
  color: var(--text);
  outline: none;
  transition: border-color 0.2s;
}

.add-input:focus {
  border-color: var(--primary);
}

.add-input::placeholder {
  color: var(--text-muted);
}

.add-btn {
  padding: 0.75rem 1.25rem;
  background: var(--primary);
  color: #fff;
  border: none;
  border-radius: var(--radius);
  font-size: 0.95rem;
  font-weight: 600;
  cursor: pointer;
  font-family: inherit;
  white-space: nowrap;
  transition: background 0.2s;
}

.add-btn:hover:not(:disabled) {
  background: var(--primary-dark);
}

.add-btn:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.form-error {
  color: var(--danger);
  font-size: 0.85rem;
  margin-top: 0.5rem;
}

/* ========== LOADING / EMPTY ========== */
.loading {
  text-align: center;
  color: var(--text-muted);
  padding: 3rem 1rem;
  font-size: 1rem;
}

.empty-state {
  text-align: center;
  padding: 4rem 1rem;
  color: var(--text-muted);
}

.empty-icon {
  font-size: 3rem;
  display: block;
  margin-bottom: 0.75rem;
}

.empty-hint {
  font-size: 0.85rem;
  margin-top: 0.25rem;
  opacity: 0.7;
}

/* ========== SUBJECTS GRID ========== */
.subjects-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 1rem;
}

/* ========== SUBJECT CARD ========== */
.subject-card {
  background: var(--surface);
  border-radius: var(--radius);
  padding: 1.25rem;
  box-shadow: var(--shadow);
  border: 1.5px solid var(--border);
  display: flex;
  flex-direction: column;
  gap: 1rem;
  transition: box-shadow 0.2s, border-color 0.2s;
}

.subject-card:hover {
  box-shadow: var(--shadow-lg);
}

.subject-card--full {
  border-color: var(--danger);
  background: linear-gradient(135deg, #fff 0%, #fff5f5 100%);
}

.subject-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 0.5rem;
}

.subject-name {
  font-size: 1.05rem;
  font-weight: 600;
  color: var(--text);
  word-break: break-word;
  line-height: 1.3;
}

.delete-btn {
  background: none;
  border: none;
  font-size: 1.4rem;
  line-height: 1;
  color: var(--text-muted);
  cursor: pointer;
  padding: 0 0.25rem;
  border-radius: 4px;
  transition: color 0.15s, background 0.15s;
  flex-shrink: 0;
}

.delete-btn:hover:not(:disabled) {
  color: var(--danger);
  background: var(--danger-light);
}

/* ========== ABSENCE SECTION ========== */
.absence-section {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
}

.absence-label {
  font-size: 0.78rem;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--text-muted);
}

.absence-dots {
  display: flex;
  gap: 0.75rem;
}

.absence-dot {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  border: 2.5px solid var(--border);
  background: transparent;
  transition: background 0.25s, border-color 0.25s, transform 0.15s;
}

.absence-dot--used {
  background: var(--danger);
  border-color: var(--danger);
  transform: scale(1.05);
}

/* When all 3 are filled, make dots pulse */
.subject-card--full .absence-dot--used {
  animation: pulse-dot 1.8s ease-in-out infinite;
}

@keyframes pulse-dot {
  0%, 100% { box-shadow: 0 0 0 0 rgba(239,68,68,0.4); }
  50% { box-shadow: 0 0 0 6px rgba(239,68,68,0); }
}

.absence-count {
  font-size: 0.875rem;
  color: var(--text-muted);
}

.absence-warning {
  color: var(--danger);
  font-weight: 600;
}

/* ========== ABSENCE ACTIONS ========== */
.absence-actions {
  display: flex;
  gap: 0.5rem;
}

.btn {
  flex: 1 1;
  padding: 0.6rem 0.5rem;
  border: none;
  border-radius: 8px;
  font-size: 0.875rem;
  font-weight: 600;
  font-family: inherit;
  cursor: pointer;
  transition: background 0.2s, opacity 0.2s, transform 0.1s;
}

.btn:active:not(:disabled) {
  transform: scale(0.97);
}

.btn:disabled {
  opacity: 0.35;
  cursor: not-allowed;
}

.btn--increment {
  background: var(--danger);
  color: #fff;
}

.btn--increment:hover:not(:disabled) {
  background: #dc2626;
}

.btn--decrement {
  background: var(--primary-light);
  color: var(--primary-dark);
}

.btn--decrement:hover:not(:disabled) {
  background: #c7d2fe;
}

/* ========== RESPONSIVE ========== */
@media (max-width: 480px) {
  .dashboard-header {
    padding: 0.75rem 0.875rem;
  }

  .dashboard-main {
    padding: 1rem 0.875rem 2rem;
  }

  .add-form {
    flex-direction: column;
  }

  .add-btn {
    width: 100%;
  }

  .subjects-grid {
    grid-template-columns: 1fr;
  }

  .user-name {
    display: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA,uCAAuC;AACvC;EACE,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,wBAAwB;EACxB,iBAAiB;EACjB,uBAAuB;EACvB,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;EAClB,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,qBAAqB;EACrB,cAAc;EACd,+DAA+D;EAC/D,4CAA4C;AAC9C;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,qBAAqB;EACrB,wBAAwB;EACxB,uBAAuB;EACvB,6DAA6D;EAC7D,2CAA2C;AAC7C;;AAEA;EACE,6DAA6D;AAC/D;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mEAAmE;EACnE,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,mCAAmC;EACnC,uCAAuC;AACzC;;AAEA,qCAAqC;AACrC;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,0EAA0E;AAC5E;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;EACnB,oBAAoB;EACpB,WAAW;EACX,gBAAgB;EAChB,sCAAsC;EACtC,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;EAC/B,oBAAoB;EACpB,kBAAkB;EAClB,qBAAqB;EACrB,mBAAmB;EACnB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,WAAW;EACX,wBAAwB;EACxB,0BAA0B;EAC1B,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,2CAA2C;EAC3C,oBAAoB;AACtB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA,oCAAoC;AACpC;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,0BAA0B;EAC1B,sCAAsC;EACtC,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,gDAAgD;EAChD,cAAc;AAChB;;AAEA;EACE,gCAAgC;EAChC,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,wBAAwB;EACxB,kBAAkB;EAClB,wBAAwB;EACxB,iBAAiB;EACjB,eAAe;EACf,oBAAoB;EACpB,yCAAyC;AAC3C;;AAEA;EACE,+BAA+B;EAC/B,oBAAoB;EACpB,2BAA2B;AAC7B;;AAEA;EACE,SAAO;EACP,0BAA0B;EAC1B,gBAAgB;EAChB,cAAc;EACd,WAAW;AACb;;AAEA,mCAAmC;AACnC;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,SAAO;EACP,qBAAqB;EACrB,iCAAiC;EACjC,4BAA4B;EAC5B,kBAAkB;EAClB,oBAAoB;EACpB,0BAA0B;EAC1B,kBAAkB;EAClB,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,0BAA0B;EAC1B,WAAW;EACX,YAAY;EACZ,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA,0CAA0C;AAC1C;EACE,kBAAkB;EAClB,wBAAwB;EACxB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;AACd;;AAEA,wCAAwC;AACxC;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA,uCAAuC;AACvC;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,gBAAgB;EAChB,yBAAyB;EACzB,iCAAiC;EACjC,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,8CAA8C;AAChD;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,0DAA0D;AAC5D;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,cAAc;EACd,wBAAwB;EACxB,eAAe;EACf,kBAAkB;EAClB,kBAAkB;EAClB,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,+BAA+B;AACjC;;AAEA,0CAA0C;AAC1C;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iCAAiC;EACjC,uBAAuB;EACvB,iEAAiE;AACnE;;AAEA;EACE,yBAAyB;EACzB,2BAA2B;EAC3B,sBAAsB;AACxB;;AAEA,2CAA2C;AAC3C;EACE,8CAA8C;AAChD;;AAEA;EACE,WAAW,uCAAuC,EAAE;EACpD,MAAM,uCAAuC,EAAE;AACjD;;AAEA;EACE,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA,0CAA0C;AAC1C;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,SAAO;EACP,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,eAAe;EACf,yDAAyD;AAC3D;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gCAAgC;EAChC,0BAA0B;AAC5B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,qCAAqC;AACrC;EACE;IACE,yBAAyB;EAC3B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":["/* ========== RESET & BASE ========== */\n*, *::before, *::after {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n}\n\n:root {\n  --primary: #6366f1;\n  --primary-dark: #4f46e5;\n  --primary-light: #e0e7ff;\n  --danger: #ef4444;\n  --danger-light: #fee2e2;\n  --warning: #f97316;\n  --warning-light: #ffedd5;\n  --success: #22c55e;\n  --bg: #f8fafc;\n  --surface: #ffffff;\n  --border: #e2e8f0;\n  --text: #1e293b;\n  --text-muted: #64748b;\n  --radius: 12px;\n  --shadow: 0 1px 3px rgba(0,0,0,.08), 0 4px 16px rgba(0,0,0,.06);\n  --shadow-lg: 0 4px 24px rgba(99,102,241,.15);\n}\n\n/* ========== DARK MODE ========== */\n[data-theme=\"dark\"] {\n  --bg: #0f172a;\n  --surface: #1e293b;\n  --border: #334155;\n  --text: #f1f5f9;\n  --text-muted: #94a3b8;\n  --primary-light: #1e1b4b;\n  --danger-light: #2d0a0a;\n  --shadow: 0 1px 3px rgba(0,0,0,.4), 0 4px 16px rgba(0,0,0,.3);\n  --shadow-lg: 0 4px 24px rgba(99,102,241,.3);\n}\n\n[data-theme=\"dark\"] .subject-card--full {\n  background: linear-gradient(135deg, #1e293b 0%, #2d1515 100%);\n}\n\n[data-theme=\"dark\"] .btn--decrement {\n  background: #1e1b4b;\n  color: #a5b4fc;\n}\n\n[data-theme=\"dark\"] .btn--decrement:hover:not(:disabled) {\n  background: #312e81;\n}\n\nbody {\n  font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;\n  background: var(--bg);\n  color: var(--text);\n  min-height: 100dvh;\n  -webkit-font-smoothing: antialiased;\n  transition: background 0.2s, color 0.2s;\n}\n\n/* ========== LOGIN PAGE ========== */\n.login-page {\n  min-height: 100dvh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 1rem;\n  background: linear-gradient(135deg, #6366f1 0%, #8b5cf6 50%, #a78bfa 100%);\n}\n\n.login-card {\n  background: var(--surface);\n  border-radius: 20px;\n  padding: 2.5rem 2rem;\n  width: 100%;\n  max-width: 380px;\n  box-shadow: 0 20px 60px rgba(0,0,0,.2);\n  text-align: center;\n}\n\n.login-icon {\n  font-size: 3rem;\n  margin-bottom: 0.75rem;\n}\n\n.login-title {\n  font-size: 1.75rem;\n  font-weight: 700;\n  color: var(--text);\n  margin-bottom: 0.25rem;\n}\n\n.login-subtitle {\n  color: var(--text-muted);\n  font-size: 0.9rem;\n  margin-bottom: 1.75rem;\n}\n\n.error-banner {\n  background: var(--danger-light);\n  color: var(--danger);\n  border-radius: 8px;\n  padding: 0.75rem 1rem;\n  font-size: 0.875rem;\n  margin-bottom: 1.25rem;\n  line-height: 1.4;\n}\n\n.login-btn {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.6rem;\n  width: 100%;\n  padding: 0.875rem 1.5rem;\n  background: var(--primary);\n  color: #fff;\n  border: none;\n  border-radius: 10px;\n  font-size: 1rem;\n  font-weight: 600;\n  cursor: pointer;\n  transition: background 0.2s, transform 0.1s;\n  font-family: inherit;\n}\n\n.login-btn:hover {\n  background: var(--primary-dark);\n}\n\n.login-btn:active {\n  transform: scale(0.98);\n}\n\n.login-btn-icon {\n  width: 20px;\n  height: 20px;\n}\n\n/* ========== DASHBOARD ========== */\n.dashboard {\n  min-height: 100dvh;\n  display: flex;\n  flex-direction: column;\n}\n\n.dashboard-header {\n  background: var(--surface);\n  border-bottom: 1px solid var(--border);\n  padding: 0.875rem 1rem;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  position: sticky;\n  top: 0;\n  z-index: 10;\n  box-shadow: 0 1px 4px rgba(0,0,0,.06);\n}\n\n.dashboard-title {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.dashboard-icon {\n  font-size: 1.4rem;\n}\n\n.dashboard-title h1 {\n  font-size: 1.2rem;\n  font-weight: 700;\n  color: var(--primary);\n}\n\n.dashboard-user {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n.user-name {\n  font-size: 0.8rem;\n  color: var(--text-muted);\n  max-width: 120px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.theme-btn {\n  background: none;\n  border: 1px solid var(--border);\n  border-radius: 8px;\n  width: 34px;\n  height: 34px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1rem;\n  cursor: pointer;\n  transition: background 0.15s, border-color 0.15s;\n  flex-shrink: 0;\n}\n\n.theme-btn:hover {\n  background: var(--primary-light);\n  border-color: var(--primary);\n}\n\n.logout-btn {\n  background: none;\n  border: 1px solid var(--border);\n  color: var(--text-muted);\n  border-radius: 8px;\n  padding: 0.35rem 0.75rem;\n  font-size: 0.8rem;\n  cursor: pointer;\n  font-family: inherit;\n  transition: background 0.15s, color 0.15s;\n}\n\n.logout-btn:hover {\n  background: var(--danger-light);\n  color: var(--danger);\n  border-color: var(--danger);\n}\n\n.dashboard-main {\n  flex: 1;\n  padding: 1.25rem 1rem 2rem;\n  max-width: 900px;\n  margin: 0 auto;\n  width: 100%;\n}\n\n/* ========== ADD FORM ========== */\n.add-section {\n  margin-bottom: 1.5rem;\n}\n\n.add-form {\n  display: flex;\n  gap: 0.5rem;\n}\n\n.add-input {\n  flex: 1;\n  padding: 0.75rem 1rem;\n  border: 1.5px solid var(--border);\n  border-radius: var(--radius);\n  font-size: 0.95rem;\n  font-family: inherit;\n  background: var(--surface);\n  color: var(--text);\n  outline: none;\n  transition: border-color 0.2s;\n}\n\n.add-input:focus {\n  border-color: var(--primary);\n}\n\n.add-input::placeholder {\n  color: var(--text-muted);\n}\n\n.add-btn {\n  padding: 0.75rem 1.25rem;\n  background: var(--primary);\n  color: #fff;\n  border: none;\n  border-radius: var(--radius);\n  font-size: 0.95rem;\n  font-weight: 600;\n  cursor: pointer;\n  font-family: inherit;\n  white-space: nowrap;\n  transition: background 0.2s;\n}\n\n.add-btn:hover:not(:disabled) {\n  background: var(--primary-dark);\n}\n\n.add-btn:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.form-error {\n  color: var(--danger);\n  font-size: 0.85rem;\n  margin-top: 0.5rem;\n}\n\n/* ========== LOADING / EMPTY ========== */\n.loading {\n  text-align: center;\n  color: var(--text-muted);\n  padding: 3rem 1rem;\n  font-size: 1rem;\n}\n\n.empty-state {\n  text-align: center;\n  padding: 4rem 1rem;\n  color: var(--text-muted);\n}\n\n.empty-icon {\n  font-size: 3rem;\n  display: block;\n  margin-bottom: 0.75rem;\n}\n\n.empty-hint {\n  font-size: 0.85rem;\n  margin-top: 0.25rem;\n  opacity: 0.7;\n}\n\n/* ========== SUBJECTS GRID ========== */\n.subjects-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));\n  gap: 1rem;\n}\n\n/* ========== SUBJECT CARD ========== */\n.subject-card {\n  background: var(--surface);\n  border-radius: var(--radius);\n  padding: 1.25rem;\n  box-shadow: var(--shadow);\n  border: 1.5px solid var(--border);\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  transition: box-shadow 0.2s, border-color 0.2s;\n}\n\n.subject-card:hover {\n  box-shadow: var(--shadow-lg);\n}\n\n.subject-card--full {\n  border-color: var(--danger);\n  background: linear-gradient(135deg, #fff 0%, #fff5f5 100%);\n}\n\n.subject-header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 0.5rem;\n}\n\n.subject-name {\n  font-size: 1.05rem;\n  font-weight: 600;\n  color: var(--text);\n  word-break: break-word;\n  line-height: 1.3;\n}\n\n.delete-btn {\n  background: none;\n  border: none;\n  font-size: 1.4rem;\n  line-height: 1;\n  color: var(--text-muted);\n  cursor: pointer;\n  padding: 0 0.25rem;\n  border-radius: 4px;\n  transition: color 0.15s, background 0.15s;\n  flex-shrink: 0;\n}\n\n.delete-btn:hover:not(:disabled) {\n  color: var(--danger);\n  background: var(--danger-light);\n}\n\n/* ========== ABSENCE SECTION ========== */\n.absence-section {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.absence-label {\n  font-size: 0.78rem;\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: var(--text-muted);\n}\n\n.absence-dots {\n  display: flex;\n  gap: 0.75rem;\n}\n\n.absence-dot {\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  border: 2.5px solid var(--border);\n  background: transparent;\n  transition: background 0.25s, border-color 0.25s, transform 0.15s;\n}\n\n.absence-dot--used {\n  background: var(--danger);\n  border-color: var(--danger);\n  transform: scale(1.05);\n}\n\n/* When all 3 are filled, make dots pulse */\n.subject-card--full .absence-dot--used {\n  animation: pulse-dot 1.8s ease-in-out infinite;\n}\n\n@keyframes pulse-dot {\n  0%, 100% { box-shadow: 0 0 0 0 rgba(239,68,68,0.4); }\n  50% { box-shadow: 0 0 0 6px rgba(239,68,68,0); }\n}\n\n.absence-count {\n  font-size: 0.875rem;\n  color: var(--text-muted);\n}\n\n.absence-warning {\n  color: var(--danger);\n  font-weight: 600;\n}\n\n/* ========== ABSENCE ACTIONS ========== */\n.absence-actions {\n  display: flex;\n  gap: 0.5rem;\n}\n\n.btn {\n  flex: 1;\n  padding: 0.6rem 0.5rem;\n  border: none;\n  border-radius: 8px;\n  font-size: 0.875rem;\n  font-weight: 600;\n  font-family: inherit;\n  cursor: pointer;\n  transition: background 0.2s, opacity 0.2s, transform 0.1s;\n}\n\n.btn:active:not(:disabled) {\n  transform: scale(0.97);\n}\n\n.btn:disabled {\n  opacity: 0.35;\n  cursor: not-allowed;\n}\n\n.btn--increment {\n  background: var(--danger);\n  color: #fff;\n}\n\n.btn--increment:hover:not(:disabled) {\n  background: #dc2626;\n}\n\n.btn--decrement {\n  background: var(--primary-light);\n  color: var(--primary-dark);\n}\n\n.btn--decrement:hover:not(:disabled) {\n  background: #c7d2fe;\n}\n\n/* ========== RESPONSIVE ========== */\n@media (max-width: 480px) {\n  .dashboard-header {\n    padding: 0.75rem 0.875rem;\n  }\n\n  .dashboard-main {\n    padding: 1rem 0.875rem 2rem;\n  }\n\n  .add-form {\n    flex-direction: column;\n  }\n\n  .add-btn {\n    width: 100%;\n  }\n\n  .subjects-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .user-name {\n    display: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
